const localPublishTimePattern =
  /^(\d{4})[/-](\d{1,2})[/-](\d{1,2})(?:\s+|T)(\d{1,2}):(\d{1,2})(?::(\d{1,2})(?:\.(\d{1,3}))?)?$/;

const parseLocalPublishTime = (raw: string) => {
  const matched = raw.match(localPublishTimePattern);
  if (!matched) return undefined;

  const [, yearText, monthText, dayText, hourText, minuteText, secondText = '0', millisecondText = '0'] =
    matched;
  const year = Number(yearText);
  const month = Number(monthText);
  const day = Number(dayText);
  const hour = Number(hourText);
  const minute = Number(minuteText);
  const second = Number(secondText);
  const millisecond = Number(millisecondText.padEnd(3, '0'));

  const date = new Date(year, month - 1, day, hour, minute, second, millisecond);
  const isValid =
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day &&
    date.getHours() === hour &&
    date.getMinutes() === minute &&
    date.getSeconds() === second &&
    date.getMilliseconds() === millisecond;

  return isValid ? date : null;
};

export const parsePublishTime = (value?: string) => {
  if (!value?.trim()) return null;
  const raw = value.trim();

  if (/^\d+$/.test(raw)) {
    const timestamp = Number(raw);
    const date = new Date(raw.length <= 10 ? timestamp * 1000 : timestamp);
    return Number.isNaN(date.getTime()) ? null : date;
  }

  const localDate = parseLocalPublishTime(raw);
  if (localDate !== undefined) return localDate;

  const date = new Date(raw);
  return Number.isNaN(date.getTime()) ? null : date;
};
